import { List, ListItem } from "@mui/material";
import { IRoutePartProps } from "./RouteDescription";
import { RoadFeaturesWithBruksklasse, SpesiellBegrensning } from "../../services/RuteplanAPI";


export function SpesielleBegrensningerBruksklasse(props: IRoutePartProps) {
    const roadFeatures = props.roadFeatures as RoadFeaturesWithBruksklasse;

    return (
        <>
            {roadFeatures && roadFeatures.spesielleBegrensningerBruksklasse && 
            <List>         
                {roadFeatures.spesielleBegrensningerBruksklasse.map( (bruksklasseBegrensning: SpesiellBegrensning, index: number) => {
                    return (
                        <ListItem 
                        key={`${bruksklasseBegrensning.attributeNote} - ${index}`} 
                        className="roadFeature"
                        onClick={(event) => {props.onClick(bruksklasseBegrensning, event)}}
                        onMouseEnter={() => props.onMouseEnterItem(bruksklasseBegrensning)}
                        onMouseLeave={props.onMouseLeaveItem}>
                            Bruksklasse begrensninger: {bruksklasseBegrensning.attributeNote}                            
                        </ListItem>
                    )
                })}
            </List>
            }
        </>
    )
}